<template>
	<div class="tian_div">
		<div class="centerWidth">
			<section class="xtianbao_h1">
				<div class="my-title">一键智能填报</div>
			</section>

			<div class="tian_list">
				<ul>
					<li>
						<h6 class="tian_title">选择批次</h6>
						<div class="tian_biao">
							<div class="tian_head biao_one flex">
								<div class="tian_one">批次</div>
								<div class="tian_one">考生类型/批次线</div>
								<div class="tian_one">操作</div>
							</div>
							<div class="tian_head biao_one biao_one_bg flex" v-if="type==1">
								<div class="tian_one">本科批</div>
								<div class="tian_one">{{ bkp }}</div>
								<div class="tian_one"><button type="button" @click="xzTianBao(1, 1)">开始</button></div>
							</div>
							<div class="tian_head biao_one biao_one_bg flex" v-if="type==2">
								<div class="tian_one">高职专科批</div>
								<div class="tian_one">{{ zkp }}</div>
								<div class="tian_one"><button type="button" @click="xzTianBao(2, 1)">开始</button></div>
							</div>
						</div>
					</li>

					<li>
						<h6 class="tian_title">我的志愿表(10条/页)</h6>
						<div class="tian_biao">
							<div class="tian_head biao_two flex">
								<div class="tian_one">编号</div>
								<div class="tian_one two_kuan">学生姓名</div>
								<div class="tian_one">总分</div>
								<div class="tian_one">选考科目</div>
								<div class="tian_one two_kuan">更新时间</div>
								<div class="tian_one">操作</div>
							</div>
							<div class="tian_head biao_two biao_two_color biao_one_bg flex"
								v-for="(item, index) in tableList" :key="index">
								<div class="tian_one">{{ index + 1 }}</div>
								<div class="tian_one two_kuan">{{ item.Name }}</div>
								<div class="tian_one">{{ item.TotleScore }}</div>
								<div class="tian_one">
									{{
										item.Subject1 == 1
											? '化学'
											: item.Subject1 == 2
											? '生物'
											: item.Subject1 == 3
											? '政治'
											: item.Subject1 == 4
											? '历史'
											: item.Subject1 == 5
											? '地理'
											: item.Subject1 == 6
											? '技术'
											: item.Subject1 == 8
											? '物理'
											: item.Subject1 == 9
											? '文综'
											: item.Subject1 == 10
											? '理综'
											: '其他'
									}}
									/{{
										item.Subject2 == 1
											? '化学'
											: item.Subject2 == 2
											? '生物'
											: item.Subject2 == 3
											? '政治'
											: item.Subject2 == 4
											? '历史'
											: item.Subject2 == 5
											? '地理'
											: item.Subject2 == 6
											? '技术'
											: item.Subject2 == 8
											? '物理'
											: item.Subject1 == 9
											? '文综'
											: item.Subject1 == 10
											? '理综'
											: '其他'
									}}
									/{{
										item.Subject3 == 1
											? '化学'
											: item.Subject3 == 2
											? '生物'
											: item.Subject3 == 3
											? '政治'
											: item.Subject3 == 4
											? '历史'
											: item.Subject3 == 5
											? '地理'
											: item.Subject3 == 6
											? '技术'
											: item.Subject3 == 8
											? '物理'
											: item.Subject1 == 9
											? '文综'
											: item.Subject1 == 10
											? '理综'
											: '其他'
									}}
								</div>
								<div class="tian_one two_kuan">{{ item.CreateTime }}</div>
								<div class="tian_one two_btn flexCenter">
									<p @click="xzTianBao(item.Id, 2)">查看</p>
									<p v-on:click="confirmDelete(item.Id)">删除</p>
								</div>
							</div>
							<el-pagination
							  background
							  @current-change="handleCurrentChange"
							  :current-page.sync="currentPage"
							  layout="prev, pager, next"
							  :total="total">
							</el-pagination>
						</div>
					</li>
				</ul>
			</div>

			<div class="hui_div">
				<div class="hui_red">重要提示:</div>
				<p>{{ Notes }}</p>
			</div>

			<!-- <div class="flexCenter"><button type="button" class="hui_btn">下一步</button></div> -->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableList: [],
				Notes: '',
				bkp: '',
				zkp: '',
				type:0,
				total:0,
				currentPage:1
			};
		},
		mounted() {
			this.type = this.$route.query.type?parseInt(this.$route.query.type):0;
			console.log('参数',this.$route.query);
			localStorage.setItem('YI_KEY', this.$route.query.key);
			this.GetVolunteer(1);
			this.GetUserNotes();
			this.GetLastProvinceLine();
		},
		methods: {
			handleCurrentChange(e){
				console.log('e');
			},
			xzTianBao(id, type) {
				if (type === 1) {
					this.$router.push({
						path: '/xzTianBao',
						query: {
							type: id
						}
					});
				} else {
					this.$router.push({
						path: '/xzTianBao',
						query: {
							vId: id
						}
					});
				}
			},
			openDel() {
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			},
			// 最新一年的省控线
			GetLastProvinceLine: function() {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/LastProvinceLine',
					'GET', {},
					function(res) {
						console.log('最新一年的省控线', res);
						if (res.flag) {
							that.bkp = res.bk;
							that.zkp = res.zk;
						}
					},
					function(res) {}
				);
			},
			// 获取志愿列表
			GetVolunteer: function(pg) {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetVolunteerBaseList?page='+pg+'&pageSize=10',
					'GET',
					{},
					function(res) {
						console.log('获取志愿列表',res);
						if (res.code === 0) {
							that.currentPage = pg;
							that.tableList = res.data;
							that.total = res.totalCount;
						}
					},
					function(res) {}
				);
			},
			// 确认是否删除
			confirmDelete(id) {
				this.$confirm('您确认要删除该数据吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.DeleteVolunteer(id);
				});
			},
			// 删除志愿列表
			DeleteVolunteer: function(id) {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/DeleteVolunteerBase?id=' + id,
					'GET',
					that.info,
					function(res) {
						console.log('删除志愿列表');
						console.log(res);
						if (res.code === 0) {
							that.GetVolunteer(1);
						}
					},
					function(res) {}
				);
			},
			// 获取用户须知
			GetUserNotes: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetUserNotes',
					'GET',
					that.info,
					function(res) {
						console.log('获取用户须知');
						console.log(res);
						if (res.code === 0) {
							that.Notes = res.data ? res.data.Content : '';
						}
					},
					function(res) {}
				);
			}
		}
	};
</script>

<style scoped>
	.hui_btn {
		width: 200px;
		height: 40px;
		border-radius: 4px;
		background-color: #444444;
		font-size: 14px;
		color: #fff;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
	}

	.hui_div>p {
		color: #333333;
		font-size: 14px;
		line-height: 30px;
	}

	.hui_red {
		color: #fa4237;
		font-size: 18px;
	}

	.hui_div {
		background-color: #f9f9f9;
		padding: 40px;
		box-sizing: border-box;
		margin-top: 40px;
		margin-bottom: 60px;
	}

	/* hui_div */

	.two_btn p::after {
		content: '';
		width: 100%;
		height: 1px;
		position: absolute;
		left: 0;
		bottom: 17px;
		margin-bottom: 0;
		z-index: 1;
		background-color: #a6a6a6;
	}

	.two_btn p {
		color: #000000;
		margin: 0 20px;
		position: relative;
		cursor: pointer;
	}

	.biao_one .tian_one {
		width: 33.33%;
	}

	.biao_two .tian_one {
		width: 16.6%;
		border-right: solid 1px #eeeeee;
	}

	.biao_two_color .tian_one {
		font-size: 14px;
		color: #666666;
	}

	.biao_two .two_kuan {
		width: 230px;
	}

	.biao_two .tian_one:last-child {
		border-right: none;
	}

	.biao_one_bg {
		background-color: transparent !important;
	}

	.tian_one button {
		font-size: 14px;
		color: #005371;
		width: 80px;
		height: 30px;
		border-radius: 4px;
		line-height: 30px;
		text-align: center;
		border: solid 1px #005371;
		cursor: pointer;
	}

	.biao_one .tian_one:nth-child(2) {
		width: 450px;
		box-sizing: border-box;
		border-left: solid 1px #eeeeee;
		border-right: solid 1px #eeeeee;
	}

	.tian_one {
		font-size: 16px;
		color: #333333;
		text-align: center;
	}

	.tian_head {
		height: 60px;
		line-height: 60px;
		background-color: #f5f5f5;
		border-bottom: solid 1px #eeeeee;
	}

	.tian_head:last-child {
		border-bottom: none;
	}

	.tian_biao {
		border: solid 1px #eeeeee;
		margin-top: 18px;
	}

	.tian_title {
		font-size: 16px;
		color: #000000;
		font-weight: normal;
		padding-left: 16px;
		position: relative;
	}

	.tian_title::after {
		content: '';
		width: 4px;
		height: 20px;
		background-color: #000000;
		position: absolute;
		left: 0;
		top: 50%;
		margin-top: -10px;
		z-index: 1;
	}

	.tian_list li {
		margin-top: 40px;
	}

	.centerWidth {
		background-color: #fff;
		padding: 0 18px 30px 18px;
	}

	.tian_div {
		padding: 20px 0;
	}
</style>
